module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-registration"
  }, [_c('form', {
    on: {
      "keyUp": _vm.driverLicenseUpdated
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Document Type   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('selectize-document-type', {
    on: {
      "optionSelected": _vm.selectDocumentType
    }
  })], 1)])]), (_vm.documentType) ? _c('div', {
    staticClass: "document-fields"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.documentType.has_expiry) ? _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Expiry   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('date-picker', {
    model: {
      value: (_vm.document.expiry_date),
      callback: function($$v) {
        _vm.$set(_vm.document, "expiry_date", $$v)
      },
      expression: "document.expiry_date"
    }
  })], 1)]) : _vm._e(), (_vm.documentType.has_emission) ? _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Issue date   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('date-picker', {
    model: {
      value: (_vm.document.issue_date),
      callback: function($$v) {
        _vm.$set(_vm.document, "issue_date", $$v)
      },
      expression: "document.issue_date"
    }
  })], 1)]) : _vm._e(), (_vm.documentType.has_number) ? _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Number   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document.number),
      expression: "document.number"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.document.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document, "number", $event.target.value)
      }
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [(_vm.documentType.has_issuer) ? _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Issued by   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document.issuer),
      expression: "document.issuer"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.document.issuer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document, "issuer", $event.target.value)
      }
    }
  })], 1)]) : _vm._e(), (_vm.documentType.has_country) ? _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Issue country   "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('selectize-country', {
    on: {
      "optionSelected": _vm.selectLicenseCountry
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.documentType.attachment_views), function(attachment, index) {
    return _c('div', {
      staticClass: "upload"
    }, [_c('label', [_vm._v("Upload " + _vm._s(attachment) + "  "), _c('tooltip', {
      attrs: {
        "open": true,
        "position": 'right',
        "tip": 'Document Upload Required'
      }
    }, [_c('span', {
      staticClass: "fa fa-star"
    })])], 1), _c('dropzone', {
      attrs: {
        "id": '#myVueDropzone' + index,
        "url": _vm.dropzoneUrl
      },
      on: {
        "vdropzone-success": function (file, response) {
          _vm.uploaded(file, response, attachment)
        }
      }
    })], 1)
  }), 0)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Document")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d55c7e0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateDriverLicense.vue
// module id = 2317
// module chunks = 1